import { Injectable } from '@angular/core';
import { gql } from '@apollo/client';
import { Query } from 'apollo-angular';

export interface TintingBase {
  sku: string;
}
export interface TintedColorBase {
  baseMaterialNumber: string;
  tinting: TintingBase | null;
}

export interface TintedColorBasesQueryResponse {
  colorBases: TintedColorBase[];
}

export interface TintedColorBasesQueryVariables {
  productGroupId: string;
  colorCode: string;
  colorId?: string;
  paletteCode: string;
  languageCode: string;
}

@Injectable({
  providedIn: 'root',
})
export class TintedColorBasesQuery extends Query<TintedColorBasesQueryResponse, TintedColorBasesQueryVariables> {
  override document = gql`
    query (
      $productGroupId: String
      $colorCode: NonEmptyString!
      $colorId: String
      $paletteCode: NonEmptyString!
      $languageCode: NonEmptyString!
    ) {
      colorBases(
        productColor: {
          productGroupId: $productGroupId
          colorCode: $colorCode
          colorId: $colorId
          paletteCode: $paletteCode
        }
        languageCode: $languageCode
      ) {
        baseMaterialNumber
        tinting {
          sku
        }
      }
    }
  `;
}
